export default {
    index: {
        listagem_faixa_resultado: 'Listagem de Faixa de Resultado',
        faixa_resultado_nao_encontrada: 'Nenhuma faixa de resultado encontrada',
        criar_faixa_resultado: 'Criar Faixa de Resultado',
        origem: 'Origem',
        destino: 'Destino',
        exame: 'Exame',
        editar: 'Editar'
    },
    form: {
        integracao_origem: 'Integração de Origem',
        integracao_destino: 'Integração de Destino',
        exame: 'Exame',
        condicoes: 'Condições',
        salvar: 'Salvar',
        status_descricao: 'Status da faixa de resultado',
        titulo_editar: 'Editar Faixa de Resultado',
        titulo_criar: 'Criar Nova Faixa de Resultado',
        integracao_origem_obrigatoria: 'A seleção da integração de origem é obrigatória!',
        integracao_destino_obrigatoria: 'A seleção da integração de destino é obrigatória!',
        exame_obrigatorio: 'A seleção do exame é obrigatória!',
        criada_sucesso: 'Configuração de faixa de resultado criada com Sucesso',
        editada_sucesso: 'Configuração de faixa de resultado atualizada com Sucesso'
    }
}